import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthShell from "@/pages/auth/AuthShell";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await login(form.email, form.password);
      toast.success("Welcome back!");
      nav(params.get("redirect") || "/dashboard");
    } catch (e2) { const m = apiError(e2); setErr(m); toast.error(m); }
    setLoading(false);
  };

  return (
    <AuthShell title={t("auth.loginTitle")} subtitle={t("auth.loginSub")}
      footer={<>{t("auth.noAccount")} <Link to="/register" className="text-amber-400 font-semibold" data-testid="to-register-link">{t("auth.signup")}</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        {err && <div className="rounded-lg bg-red-500/10 border border-red-500/30 text-red-300 text-sm px-4 py-3" data-testid="login-error">{err}</div>}
        <div><label className="label-lux">{t("auth.email")}</label><input required type="email" className="input-lux mt-2" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" /></div>
        <div><label className="label-lux">{t("auth.password")}</label><input required type="password" className="input-lux mt-2" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" /></div>
        <div className="text-right"><Link to="/forgot-password" className="text-sm text-amber-400" data-testid="forgot-link">{t("auth.forgot")}</Link></div>
        <button disabled={loading} className="gold-btn w-full" data-testid="login-submit-btn">{loading ? <Loader2 className="animate-spin" size={18} /> : t("auth.signin")}</button>
      </form>
    </AuthShell>
  );
}
